import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useSignTypedData } from "wagmi";
import { useRequireChain } from "../../hooks/useRequireChain";
import { parseSignatureError } from "../../lib/errors";
import { useWithConnectorErrorRetry } from "./useWithConnectorErrorRetry";
export const useEvmSignTypedFunction = () => {
  const $ = _c(4);
  const {
    requireChain
  } = useRequireChain();
  const {
    signTypedDataAsync
  } = useSignTypedData();
  const withConnectorErrorRetry = useWithConnectorErrorRetry();
  let t0;
  if ($[0] !== requireChain || $[1] !== signTypedDataAsync || $[2] !== withConnectorErrorRetry) {
    t0 = async t1 => {
      const {
        address,
        domain,
        message,
        primaryType,
        types
      } = t1;
      ;
      try {
        const signature = await withConnectorErrorRetry(async () => {
          await requireChain(domain.chainId);
          return await signTypedDataAsync({
            domain,
            message,
            primaryType,
            types,
            account: address
          });
        });
        let v = Number.parseInt(signature.slice(-2), 16);
        if (v < 27) {
          v = v + 27;
        }
        const normalizedSignature = signature.slice(0, -2) + v.toString(16);
        return normalizedSignature;
      } catch (t2) {
        const err = t2;
        const error = err;
        const externalError = parseSignatureError(error);
        throw externalError;
      }
    };
    $[0] = requireChain;
    $[1] = signTypedDataAsync;
    $[2] = withConnectorErrorRetry;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const signTyped = t0;
  return signTyped;
};